<template>
    <div class="main-view">
        <home-nav  ref="homeNavRef" class="m-hidden-view"></home-nav>
        <gzh-code-view class="gzh-hidden-view"></gzh-code-view>

        <div class="m-hidden-view">
            <van-image v-if="!!topImageUrl" :src="topImageUrl" class="top-img" fit="cover"/>
            <van-image v-else :src="require('../../assets/logo/top.png')"  class="top-img" fit="cover"/>
        </div>

        <div class="m-title">
            <div style="display: flex;height: 70px;align-items: center;">
                <van-icon style="margin-right: 15px;" name="arrow-left" size="25"/>
                {{gameName}}
            </div>
        </div>

        <div style="width: 100%;min-height: calc(100vh - 380px); max-width: 900px;margin: 0 auto;">

            <div class="game-info-view">
                <div class="game-base-view">
                    <img :src="icon" class="game-icon">
                    <div class="game-title-view">
                        <span class="game-name">{{gameName}}</span>
                        <div class="game-tag-view">
                            <span v-for="tag in tagList">{{tag}}</span>
                        </div>
                        <span>{{gameTopic}} <span style="color: #15a26d;margin-left: 15px;">{{gameSize}}</span></span>
                    </div>

                    <div class="m-hidden-view" style="width: 200px;height: 140px;display:flex;flex-direction: column;align-items: center;justify-content: space-between; position: absolute;right: 30px;">
                        <div  @click="downloadGameAndroid" class="download-button">
                            <img v-if="false" src="../../assets/android-white.png" style="width: 25px;height: 25px;margin-right: 10px;">
                            <span>安卓下载</span>
                        </div>
                      <div  @click="downloadGameIOS" class="download-button">
                        <img v-if="false" src="../../assets/android-white.png" style="width: 25px;height: 25px;margin-right: 10px;">
                        <span>苹果下载</span>
                      </div>
                      <div  @click="downloadGamePC" class="download-button">
                        <img v-if="false" src="../../assets/android-white.png" style="width: 25px;height: 25px;margin-right: 10px;">
                        <span>电脑下载</span>
                      </div>
                    </div>

                </div>

                <div  class="m-hidden-view" style="margin-left: 20px; width: 280px;height:200px; background-color: #ffffff;border-radius: 10px;display: flex;flex-direction: column; align-items: center;justify-content: center;">
                    <div class="pay-code-panel">
                        <div class="qr-code" ref="qrCodeUrl"></div>
                    </div>
                    <span style="font-size: 13px;color: #888888;margin-top: 10px;">手机扫一扫下载游戏</span>
                </div>
            </div>


            <div class="game-desc-view">
                <div class="top-vew-name">
                    游戏简介
                </div>

                <div class="game-desc-text">
                    <span>{{gameDesc}}</span>
                </div>

                <div ref="scrollable" class="video-img-view" @mousedown="startMove" @mouseup="endMove" @mouseleave="endMove" @mousemove="change">

                    <video v-if="!!videoUrl" :src="videoUrl" class="game-video" :controls="true" :autoplay="false" />

                    <div class="game-image-view">
                        <!--<img draggable="true" v-for="imageUrl in introImageUrlList" :src="imageUrl" style="height: 400px;margin-left: 15px;border-radius: 5px;"/>-->

                        <div v-for="(imageUrl,index) in introImageUrlList" class="game-img-list">
                            <el-image :id="'img' + index" :style="isMoving ? 'pointer-events: none' : ''"
                                    class="game-image" :src="imageUrl"
                                    :preview-src-list="introImageUrlList">
                            </el-image>
                        </div>


                    </div>
                </div>
            </div>

            <div class="game-desc-view last-info-view">
                <div class="top-vew-name">
                    在线客服
                </div>

                <div @click="openKfPage" style="font-size: 14px;cursor: pointer;user-select: none;color: #ea6e15;text-align: left;margin-top: 20px;">
                    点击跳转在线咨询页面
                </div>

                <div style="font-size: 12px;color: #888888;text-align: left;margin-top: 15px;">
                    温馨提示：苹果兑换码获取请联系客服
                </div>
            </div>

            <div class="m-bottom-view">
<!--                <div class="ios-div" @click="goGuide" v-if="!isSelfSigned&&downloading">iOS如何授权</div>-->
                <div class="m-button"  @click="downloadGameAndroid">安卓下载</div>
                <div class="m-button"  @click="downloadGameIOS">苹果下载</div>
                <div class="m-button"  @click="downloadGamePC">电脑端下载</div>
            </div>

        </div>

        <van-overlay :show="isWeixinFlag">
            <div class="overlay-panel">
                <div>
                    <img src="../../assets/weixin_arrow.png" style="width: 80px;">
                </div>
                <div class="overlay-info">
                    <p>
                        请点击右上角 ... 在浏览器中打开
                    </p>
                </div>
            </div>
        </van-overlay>

        <div class="me-login-view" v-if="showLogin" @click.self="showLogin = false">
            <home-login @login-success="handleLoginSuccess"></home-login>
        </div>

        <home-footer class="m-hidden-view"></home-footer>
    </div>
</template>

<script>
    import {request, webTokenRequest} from "@/api/request";
    import homeNav from "@/components/HomeNav";
    import HomeLogin from "@/components/HomeLogin";
    import homeFooter from "@/components/HomeFooter";
    import gzhCodeView from "@/components/GzhCodeView";
    import {Dialog, Toast} from "vant";
    import QRCode from "qrcodejs2";
    import notice from "@/api/notice";

    export default {
        name: "GLBXCQ",
        components: {
            homeNav,
            homeFooter,
            gzhCodeView,
            HomeLogin,
        },
        data() {
            return {
                gameId: '',
                gameName: '霸星传奇',
                gameDesc: '没有任务，三端互通，三职业复古，激情pk',
                gameTopic: '',
                gameSize: '',
                icon: 'https://daoyi-data.hnoss.xstore.ctyun.cn/image/qomigbde/logo.png',
                tagList: ["三端互通","三职业","复古"],
                mobileUrl: 'https://game.daoyigame.com/#/mlbxcq',
                qrCode: {},
                videoUrl: 'https://daoyi-data.hnoss.xstore.ctyun.cn/gameVideo/qomigbde/1744335541588.mp4',
                introImageUrlList: [],
                topImageUrl: '',
                isMouseDown: false,
                isMoving: false,
                startX: 0,
                scrollLeft: 0,
                downloading: false,
                androidUrl: 'https://daoyi-data.hnoss.xstore.ctyun.cn/bxcq/ml/%E9%9C%B8%E6%98%9F%E4%BC%A0%E5%A5%87.apk',
                iosUrl: 'https://hetaobao.cn/vip/dbrh',
                pcUrl: 'https://daoyi-data.hnoss.xstore.ctyun.cn/bxcq/ml/%E9%9C%B8%E6%98%9F%E4%BC%A0%E5%A5%87pc%E7%AB%AF.zip',
                gameUrl: '',
                from: '',
                gameSystem: 0,
                buttonText: '游戏下载',
                process: '',
                appStatus: 0,
                packageName: '',
                isWeixinFlag: false,
                showLogin: false,
            }
        },
        mounted() {
            // if(this.$route.query.thirdChannel) {
            //     localStorage.setItem('channel', this.$route.query.thirdChannel);
            // }
            // else if (this.$route.query.channel) {
            //     localStorage.setItem('channel', this.$route.query.channel);
            // }
            this.isWeixinFlag = this.isWeiXin();
            // this.mobileUrl = window.location.href;
            // this.gameId = this.$route.path.split('/')[2]
            // this.from = localStorage.getItem('from') || 'h5';
            // this.getGameInfo();
            this.creatQrCode();
            // window.refreshProcess = this.refreshProcess;
            // window.refreshAppInfo = this.refreshAppInfo;
        },
        methods: {
            handleLoginSuccess() {
                this.showLogin = false;
                this.isLogin = true;
            },
            openKfPage() {
                window.open('https://work.weixin.qq.com/kfid/kfc90efb6e933ede0f2', '_blank');
            },
            creatQrCode() {
                this.$refs.qrCodeUrl.innerHTML = ""
                if (this.qrCode._oQRCode) {
                    this.qrCode.clear(); //清除
                }
                this.qrCode = new QRCode(this.$refs.qrCodeUrl, {
                    text: this.mobileUrl,
                    width: 140,
                    height: 140,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: 3

                });
            },
            goGuide() {
                this.$router.push({path: '/download/iosGuide'})
            },
            downloadGameIOS() {
              window.location.href = this.iosUrl;
            },
            downloadGameAndroid() {
              window.location.href = this.androidUrl
            },
            downloadGamePC() {
              window.location.href = this.pcUrl
            },
            showDialog(msg) {
                Dialog.alert({
                    title: '提示',
                    messageAlign: 'left',
                    message: msg
                })
            },
            startMove(e) {
              this.isMouseDown = true;
              this.startX = e.pageX - this.$refs.scrollable.offsetLeft;
              this.scrollLeft = this.$refs.scrollable.scrollLeft;
            },
            endMove(e) {
              this.isMouseDown  = false;
              this.isMoving  = false;
            },
            change(e) {
              if (!this.isMouseDown) return;
              e.preventDefault();
              let x = e.pageX - this.$refs.scrollable.offsetLeft
              let walk = (x - this.startX) * 1; // 调整滚动速度
              if (walk !== 0) {
                this.isMoving  = true;
                this.$refs.scrollable.scrollLeft = this.scrollLeft - walk;
              }
            },
            isWeiXin() {
              let ua = window.navigator.userAgent.toLowerCase()
              //通过正则表达式匹配ua中是否含有MicroMessenger字符
              return ua.match(/MicroMessenger/i) == 'micromessenger'
            },
            isMobile() {
                let browser = {
                    versions: function () {
                        let u = navigator.userAgent, app = navigator.appVersion;
                        return {
                            trident: u.indexOf('Trident') > -1, //IE内核
                            presto: u.indexOf('Presto') > -1, //opera内核
                            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
                            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                            iPad: u.indexOf('iPad') > -1, //是否iPad
                            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                            weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                            qq: u.match(/\sQQ/i) == " qq" //是否QQ
                        };
                    }(),
                    language: (navigator.browserLanguage || navigator.language).toLowerCase()
                }
                // return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                return browser.versions.mobile || browser.versions.android || browser.versions.ios;
            },
        }
    }
</script>

<style scoped>
    .main-view {
        //min-width: 1400px;
        width: 100%;
        height: 100vh;
        overflow-y: scroll;
        background-color: #f5f5f5;
        position: relative;
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-view::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }
    .top-img {
        width: 100%;
        height: 270px;
    }
    .game-name {
        text-align: left;
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    }
    .game-tag-view {
        display: flex;
        white-space: nowrap;
    }
    .game-tag-view span {
        margin-right: 10px;
        //background-color: rgba(238, 109, 109, 0.1);
        border: 1px solid #f14848;
        border-radius: 3px;
        color: #f14848;
        padding: 2px 5px;
    }
    .download-button {
        width: 170px;
        height: 40px;
        border-radius: 40px;
        background-color: #7a69be;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        box-sizing: border-box;
        color: #ffffff;
        user-select: none;
        cursor: pointer;
    }
    .online-button {
        width: 170px;
        height: 50px;
        border-radius: 40px;
        background-color: #ffffff;
        border: 2px solid #7a69be;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        box-sizing: border-box;
        color: #7a69be;
        user-select: none;
        cursor: pointer;
    }
    .pay-code-panel{
        text-align: center;
        overflow: hidden;
        width: 140px;
        height: 140px;
    }
    .qr-code{
        display: inline-block;
        align-items: center;
        justify-content: center;
        text-align: center;
        overflow: hidden;
    }
    .top-vew-name {
        text-align: left;
        font-family: myFont,serif;
        color: #1a66e5;
        user-select: none;
        font-size: 35px;
    }

    .game-info-view {
        width: 100%;
        display: flex;
        margin-top: 20px;
    }

    .game-base-view {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0 30px;
        height: 200px;
        position: relative;
        background-color: #ffffff;
        border-radius: 10px;
        overflow: hidden;
    }
    .game-icon {
        width: 130px;
        height: 130px;
        border-radius: 20px;
    }
    .game-title-view {
        display: flex;
        height: 125px;
        color: #666666;
        margin-left: 25px;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 14px;
    }
    .game-desc-view {
        width: 100%;
        background-color: #ffffff;
        border-radius: 10px;
        margin-top: 20px;
        padding: 20px 30px;
        box-sizing: border-box;
    }
    .last-info-view {
        margin-bottom: 20px;
    }
    .game-desc-text {
        line-height: 33px;
        margin-top: 16px;
        text-align: left;
        font-size: 16px;
        color: #444444;
    }
    .video-img-view {
        width: 840px;
        margin-top: 25px;
        overflow: hidden;
        white-space: nowrap;
        position: relative;
        font-size: 0;
        -webkit-overflow-scrolling: touch;
    }
    .game-video {
        height: 400px;
        border-radius: 5px;
    }
    .game-image {
        width: 225px;
        height: 400px;
        border-radius: 5px;
    }
    .game-img-list {
        margin-left: 15px;
        display: inline-block
    }
    .game-image-view {
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
    }
    .m-bottom-view {
        height: 55px;
        position: fixed;
        bottom: 0;
        background-color: #ffffff;
        width: 100%;
        display: none;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        box-sizing: border-box;
    }
    .play-button {
        width: 40%;
        height: 40px;
        margin-right: -10px;
        border-radius: 40px 0 0 40px;
        background-color: #ed8850;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        box-sizing: border-box;
        color: #ffffff;
        user-select: none;
        cursor: pointer;
        clip-path: polygon(0 0, 100% 0, calc(100% - 20px) 100%, 0 100%);
    }

    .m-button {
        width: 30%;
        max-width: 100px;
        height: 30px;
        border-radius: 40px;
        background-color: #7a69be;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        box-sizing: border-box;
        color: #ffffff;
        user-select: none;
        cursor: pointer;
    }
    .m-title {
        display: none;
        font-size: 20px;
        color: #333333;
        width: 100%;
        height: 110px;
        text-align: left;
        align-items: flex-end;
        padding: 0 10px;
        position: fixed;
        z-index: 999;
        background-color: #f5f5f5;
        box-sizing: border-box;
    }

    .van-overlay {
        z-index: 1000;
    }
    .overlay-panel{
        text-align: right;
        margin-right: 15px;
        margin-top: 10px;

    }
    .overlay-info {
        text-align: center;
        width: 80%;
        margin: 20px auto;
        border-radius: 60px;
        color: white;
        font-weight: 600;
    }

    .me-login-view {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
    }

    @media screen and (max-width: 1300px) {
        .gzh-hidden-view {
            display: none !important;
        }
    }

    @media screen and (max-width: 900px) {
        .m-hidden-view {
            display: none !important;
        }
        .m-title {
            display: flex;
            align-items: flex-start;
            min-height: 60px;
            height: calc(60px + constant(safe-area-inset-top));
            height: calc(60px + env(safe-area-inset-top));
            padding-top: constant(safe-area-inset-top);
            padding-top: env(safe-area-inset-top);
            box-sizing: border-box;
            padding-left: calc(44px + constant(safe-area-inset-left));
            padding-left: calc(44px + env(safe-area-inset-left));
        }
        .back-icon {
            position: fixed !important;
            left: calc(15px + constant(safe-area-inset-left)) !important;
            left: calc(15px + env(safe-area-inset-left)) !important;
            top: calc(20px + constant(safe-area-inset-top)) !important;
            top: calc(20px + env(safe-area-inset-top)) !important;
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
        }
        .main-view {
            min-width: unset;
        }
        .game-info-view {
            width: 95%;
            margin: 110px auto 0;
        }
        .game-base-view {
            height: 100px;
            padding: 0 20px;
        }
        .game-icon {
            width: 80px;
            height: 80px;
            border-radius: 10px;
        }
        .game-title-view {
            height: 80px;
            font-size: 12px;
            margin-left: 15px;
        }
        .game-name {
            font-size: 15px;
        }
        .game-desc-view {
            width: 95%;
            margin: 10px auto 10px;
            padding: 15px 20px;
        }
        .last-info-view {
            margin-bottom: 70px;
        }
        .top-vew-name {
            font-size: 22px;
        }
        .game-desc-text {
            line-height: 24px;
            font-size: 14px;
            margin-top: 5px;
        }
        .video-img-view {
            width: 100%;
            overflow: auto;
            margin-top: 10px;
            -ms-overflow-style: none;  /* IE 10+ */
            scrollbar-width: none;  /* Firefox */
        }
        .game-video {
            width: 95%;
            height: unset;
        }
        .game-image {
            width: unset;
            height: calc((95vw - 40px) * 0.95 * 9 / 16);
        }
        .game-img-list {
            margin-left: 5px;
        }
        .main-view {
            -ms-overflow-style: none;  /* IE 10+ */
            scrollbar-width: none;  /* Firefox */
        }
        .main-view::-webkit-scrollbar {
            display: none;
        }
        .video-img-view::-webkit-scrollbar {
            display: none;
        }
        .game-image-view {
            overflow: unset;
        }
        .top-img {
            height: 150px;
        }
        .m-bottom-view {
            display: flex;
        }
    }
</style>